import { Component, OnInit } from '@angular/core';
import { Message, Messages } from 'src/app/model/messages/messages.model';
import { MessagesService } from 'src/app/services/messages/messages.service';

@Component({
  selector: 'app-messages-list',
  templateUrl: './messages-list.component.html',
  styleUrls: ['./messages-list.component.scss']
})
export class MessagesListComponent implements OnInit {

  constructor(private service: MessagesService) { }

  public messages!: Messages;

  sortOrders: number[] = [];

  ngOnInit(): void {
    this.service.getMessagesList().subscribe((messages) => {
      console.log(messages);
      this.messages = messages;
    });

  }
  sortby(column: any): void {
    console.log('Tri par la colonne ' + column);
    var sortOrder = 1;
    if(!this.sortOrders[column]){
        this.sortOrders[column] = 1;
      }
    else{
      this.sortOrders[column] = - this.sortOrders[column];
      sortOrder=this.sortOrders[column];
    }
    
    if ( this.messages != undefined ) {
      this.messages.messages_installations.sort(function (a: any, b: any) {
        var rowA = a[column];
        var rowB = b[column];
        if (rowA == undefined)
          rowA = "9";
        if (rowB == undefined)
          rowB = "9";
        if (typeof rowA == 'string') {
          if (rowA.slice(2,3)=="/" || rowB.slice(2,3)=="/") {
            // Case of a date
            rowA = rowA.slice(6,10)+rowA.slice(3,5)+rowA.slice(0,2);
            rowB = rowB.slice(6,10)+rowB.slice(3,5)+rowB.slice(0,2);
          }
          var rowA = rowA.toLowerCase();
          var rowB = rowB.toLowerCase();
        }
        if (rowA < rowB)
          return -1 * sortOrder;
        else if (rowA > rowB)
          return 1 * sortOrder;
        else return 0
      });
    }
  }

}
